import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useAIMDContext } from '../context/AIMDContext';
import { ProgramCreationProvider, useProgramCreation } from '../../../../../components/admin3/newProgram/ProgramCreationContext';
import ProgramUsers from '../../../tabs/Program/components/program tabs/ProgramUsers';
import { useAppDispatch } from '../../../../../redux/hooks';
import { fetchGroupDetails } from '../../../../../redux/slices/group-details/groupDetails';
import useProgramCreationFlowV2 from '../../../../../hooks/useProgramCreationFlowV2';

interface MembersStepProps {
  // Revamp: whether Invite & Finish may run (an audience is set or someone was
  // invited by name) — the page footer gates its button on it.
  onInviteReadinessChange?: (ready: boolean) => void;
}

const MembersStepInner: React.FC<MembersStepProps> = ({ onInviteReadinessChange }) => {
  const ctx = useAIMDContext();
  const { groupId } = ctx;
  const dispatch = useAppDispatch();
  const { dispatch: pcDispatch } = useProgramCreation();
  // Creation-flow revamp: the Members page shows the narrow-only Audience
  // section + not-yet-invited matching list, and nothing enrolls until the
  // footer's "Invite & Finish" (handled by AIMDv2Page).
  const creationFlowV2 = useProgramCreationFlowV2();

  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (groupId) {
      pcDispatch({ type: 'SET_GROUP_ID', payload: groupId });
      dispatch(fetchGroupDetails({ grpId: groupId }) as any);
      setReady(true);
    }
  }, [groupId, pcDispatch, dispatch]);

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography sx={{ fontSize: 30, fontWeight: 500, fontFamily: 'Inter', color: 'var(--Text-text-primary, #FDFDFD)' }}>
          People
        </Typography>
        {/* Creation flow: no subtitle — the Audience, Matching Members and
            Invite New Members sections explain themselves. */}
        {!creationFlowV2 && (
          <Typography sx={{ fontSize: 14, fontFamily: 'Inter', color: 'var(--Text-text-secondary, #B6B6B6)', mt: 1 }}>
            Enroll people in your program. You can also add people after publishing.
          </Typography>
        )}
      </Box>

      <Box sx={{ flex: 1, minHeight: 400 }}>
        {ready && (
          <ProgramUsers creationFlow={creationFlowV2} onInviteReadinessChange={onInviteReadinessChange} />
        )}
      </Box>
    </Box>
  );
};

/**
 * MembersStep wraps ProgramUsers inside a ProgramCreationProvider
 * so the component's useProgramCreation() call doesn't crash.
 */
const MembersStep: React.FC<MembersStepProps> = ({ onInviteReadinessChange }) => {
  return (
    <ProgramCreationProvider>
      <MembersStepInner onInviteReadinessChange={onInviteReadinessChange} />
    </ProgramCreationProvider>
  );
};

export default MembersStep;
